import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defineIntegration } from '../integration.js';
import { timestampInSeconds } from '../utils-hoist/time.js';
var INTEGRATION_NAME = 'SessionTiming';
var _sessionTimingIntegration = function _sessionTimingIntegration() {
  var startTime = timestampInSeconds() * 1000;
  return {
    name: INTEGRATION_NAME,
    processEvent: function processEvent(event) {
      var _objectSpread2;
      var now = timestampInSeconds() * 1000;
      return _objectSpread(_objectSpread({}, event), {}, {
        extra: _objectSpread(_objectSpread({}, event.extra), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, 'session:start', startTime), _defineProperty(_objectSpread2, 'session:duration', now - startTime), _defineProperty(_objectSpread2, 'session:end', now), _objectSpread2))
      });
    }
  };
};

/**
 * This function adds duration since the sessionTimingIntegration was initialized
 * till the time event was sent.
 *
 * @deprecated This integration is deprecated and will be removed in the next major version of the SDK.
 * To capture session durations alongside events, use [Context](https://docs.sentry.io/platforms/javascript/enriching-events/context/) (`Sentry.setContext()`).
 */
var sessionTimingIntegration = defineIntegration(_sessionTimingIntegration);
export { sessionTimingIntegration };